import {SET_SHEET, CLOSE_SHEET} from './types';

export const setSheet = payload => ({
  type: SET_SHEET,
  payload,
});

export const closeSheet = () => ({
  type: CLOSE_SHEET,
});
